<template>
  <article
    class="project-item | flex | rounded-2xl | px-32 py-32"
    :data-dtl="project.isDTLEnabled ? 'true' : undefined"
  >
    <hgroup>
      <h3>
        <router-link
          :to="
            isEmptyBrief(project) ? project.uri + '/client-brief' : project.uri
          "
          class="link-full"
        >
          {{ project.title }}
        </router-link>
      </h3>
      <p>
        {{ t('dates.updatedOn') }}
        <time :datetime="project.modified">{{ formattedModified }}</time>
      </p>
    </hgroup>
    <img :src="project.logo" alt="Logo" class="project-logo | rounded-sm" />
    <ol
      v-if="Array.isArray(project.steps)"
      class="project-steps"
      :data-steps="project.steps.length"
      :style="'--steps:' + project.steps.length"
    >
      <li
        v-for="step in project.steps"
        class="project-step"
        :data-status="setStatus(project.steps, project.currentStep, step)"
      >
        <span class="pill" :data-icon="step.id">
          <span>{{ t('steps.' + step.id) }}</span>
        </span>
      </li>
    </ol>
  </article>
</template>

<script setup>
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import { computed } from 'vue';
import { useProjectStore } from '../../stores/project';
import { useI18n } from 'vue-i18n';

const { project } = defineProps({ project: Object });

const { stepsLabels, setStatus, isEmptyBrief } = useProjectStore();
const { t, locale } = useI18n();

const formattedModified = computed(() =>
  dayjs(project.modified).locale(locale.value).format('dddd D MMMM YYYY')
);
</script>
